import { shape } from 'prop-types'

import pagePropertiesType from './pageProperties'
import { publicConfigType } from './publicConfig'

export const publicRuntimeConfigType = {
  publicConfig: shape(publicConfigType).isRequired,
  pageProperties: shape(pagePropertiesType).isRequired,
}
